import React, { Component } from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import {
  IVideoDetailProps,
  IVideoDetailState
} from "../../interfaces/video.interface";
import { IRootState } from "../../interfaces";
import { videoDetailRequest, getSelectedVideoRequest, pausedTimeRequest, submitRatingRequest} from "../../action";
import { FrontendUrl } from "../../config";
import Loader from '../../components/Loader/Loader';
import noImage from "../../assets/images/no-image.png";
import { AppRoutes } from '../../config';
import { ConfirmBox } from "../../helper/SweetAlert";
import Rater from 'react-rater';
import 'react-rater/lib/react-rater.css';

//const queryString = require("query-string");
class view_Video extends Component<IVideoDetailProps, IVideoDetailState> {
  constructor(props: IVideoDetailProps) {
    super(props);
    this.state = { displayvideo: "", search: "", videoId:"", takeReview: true, videosToShow: 3 };
  }
  componentDidMount = () => {
    const { search, } = this.state
    const data = { search }
    //const { match } = this.props;
    //const current: any = match.params;
    this.getVideo();
    this.props.getVideoInfo(data);
    //window.addEventListener('load', this.handleLoad);
    window.addEventListener("beforeunload", this.handleLeavePage);
    window.scrollTo(0, 0);
  };

  componentWillUnmount() { 
    //window.removeEventListener('load', this.handleLoad);
    window.removeEventListener("beforeunload", this.handleLeavePage);
    this.handleLeavePage(1);
  };
  
  /*
  handleLoad() {
    let input = document.getElementById("Viddeo-36");
    if (input) { 
    (input as HTMLVideoElement).currentTime = 2000;
    }
   }*/
   
  handleLeavePage(beforeEndCall: any) {
    if(beforeEndCall !== 1) {
      this.handleBeforeEnd(false);
    }
    let input = document.getElementsByClassName("currentVideo")[0];
    if(input && this.props && this.props.pausedTimeData) {
      console.log((input as HTMLVideoElement).currentTime);
      let lastPaused = (input as HTMLVideoElement).currentTime;
      let videoId= input.id.substring("Viddeo-".length);
        const data = {
          lastPaused,
          videoId
        };
        this.props.pausedTimeData(data);
        //const { PausedVideoReducer } = this.props;
    }
  };
   
  componentDidUpdate = async (prevProps: IVideoDetailProps, prevState: IVideoDetailState) => {
    const {
      match,
    } = this.props;
    const { params } = match;
    //const query: any = params
    if (params !== prevProps.match.params && params) {
      window.scroll(0, 0)
      await this.getVideo()
    }
    const current: any = match.params;
    const videoId = parseInt(current.id);
    let selectedVideo = document.getElementById("Viddeo-"+videoId);
    if(selectedVideo != null) {
      selectedVideo.addEventListener("ended", this.handleBeforeEnd);
      selectedVideo.addEventListener("timeupdate", this.handleVideoUpdate);
    }
  };

  handleBeforeEnd = async(manualReview: any) => {
    if(this.state.takeReview || manualReview) {
      const { value } = await ConfirmBox({
        title: "<span class='swal2-title-span'> Please Rate this video <br> How useful was this video?</span>",
        background: "#2f353a",
        html: "&nbsp;",
        confirmButtonText: 'SKIP',
        cancelButtonText: 'SUBMIT',
        cancelButtonClass: "popup-btn",
        confirmButtonClass: "popup-btn",
        raterRender: true,
        raterClose: true
      });
      //we are sending confirmbutton text as cancel & cancel one as submit to manage sweetalert functionality. even below as well
      if (!value) {
        const { match } = this.props;
        const current: any = match.params;
        const videoId = parseInt(current.id);
        let raterBox = document.getElementById("rater-box");
        let rating = 0;
        if(raterBox) {
          rating = raterBox.getElementsByClassName("is-active").length;
        }
        const data = {
          rating,
          videoId
        };
        this.props.submitRatingData(data);
        console.log("submit");
        this.setState({ takeReview: false });   
      } else {
        return;
      }
    }
  }

  getVideo = () => {
    const { match } = this.props;
    const current: any = match.params;
    const { getSelectedVideo } = this.props;
    const id = parseInt(current.id);
    this.setState({
      videoId: id,
      takeReview: true
    });
    getSelectedVideo({
      id
    });
  }

  toggle = (item: any, index: any, id: any) => {
    if(!(item.id === this.state.videoId)) {
      let input = document.getElementById(`Viddeo-${id}`);
      if (input) {
        this.setState({
          videoId: id
        });
        (input as HTMLVideoElement).pause()
        this.props.history.push(
          AppRoutes.MY_VIDEOS_VIEW.replace(
            ":id",
            item.id,
          )
        );
        this.handleLeavePage(0);
      }
    }
  }

  handleVideoUpdate = () => {
    const { match } = this.props;
    const current: any = match.params;
    //const { getSelectedVideo } = this.props;
    const id = parseInt(current.id);
    let videoElem = document.getElementById("Viddeo-"+id);
    let saveView = 0;
    if(videoElem && (videoElem as HTMLVideoElement).currentTime > 300) {
      const viewAddedIds = localStorage.getItem('viewAddedIds');
      if(viewAddedIds && viewAddedIds.indexOf(""+id) !== -1) {
        saveView = 1;
      }
      if(saveView !== 1) {
        let isSaveView=true;
        let videoId = id;
        const data = {
          videoId,
          saveView,
          isSaveView
        };
        this.props.submitRatingData(data);
        localStorage.setItem('viewAddedIds', viewAddedIds+","+id);
      }
    }
  }

  handleRating = () => {
  }

  showPopup = (id: any) => {

  }

  render() {

    const { videoDetailReducer, SelectedVideoReducer, } = this.props;
    //const { videoDetailsData } = videoDetailReducer;
    const { videoData } = SelectedVideoReducer;
    const query: any = this.props.match.params;
    return (
      <>
        {videoDetailReducer && videoDetailReducer.isLoading && SelectedVideoReducer && SelectedVideoReducer.isLoading ? (
          <Loader />
        ) : (
            <>
            
            <div id="rater-box" className="hide-element">
              <Rater rating={0} total={5} onRate={this.handleRating}/>
</div>
              <div className="main-section" id="right-container">
                <div className='col-lg-12 col-md- courses-section video-view-section'>
                  <div className="row">
                    <div className="col-lg-12 col-md-12">
                      <div className="course-navbar d-flex align-items-center">
                        <div className="mr-auto course-heading text-capitalize">
                          <h2 className="video-title">
                            Videos to get you started
                            <span className="border-heading"></span>
                            
                              
                          </h2>
                        </div>
                        <div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <section className="box-main">
                    <div className="container">
                      <div className="row">
                        <div className="col-lg-8 col-md-12">
                          {videoData.data ?
                            <>
                              <h5 className="view-video-title mt-4">{videoData.data.title}</h5>
                              <video
                                id={`Viddeo-${videoData.data.id}`}
                                width="100%"
                                className="currentVideo"
                                controlsList="nodownload"
                                controls
                                autoPlay={true}
                                playsInline
                                src={`${FrontendUrl}${videoData.data.url}${videoData.data.lastPaused}`}
                              />
                              <div className="views-ratings">
                                <div className="desc-views">
                                  <div className="video-views">{videoData.data.views}</div>
                                  <div className="video-sub-title">{videoData.data.description}</div>
                                </div>
                                <div className="star-rater">
                                  <div className="rating-div" onClick={() => {
                                      this.handleBeforeEnd(
                                        true
                                      );
                                    }}>
                                    <Rater rating={videoData.data.rating} total={5} interactive={false}/><span className="rating-count"> ({videoData.data.ratingCount})</span>
                                    <div className="leaveRating">Leave your rating</div>
                                  </div>
                                </div>
                              </div>
                            </> : null}
                        </div >
                        <div className="col-lg-4 col-md-12 mob-over">
                          <div className="filter-div view-video-filter scrollbar force-overflow view-vid-scroll">
                            <div className="title">
                              <h2>More Videos</h2>
                              <span className="border-heading"></span>
                            </div>
                            <ul className="list-unstyled scrollbar-mob" >
                              {videoDetailReducer && videoDetailReducer.videoDetailsData && videoDetailReducer.videoDetailsData.length ?
                                videoDetailReducer.videoDetailsData.map((item: any, index: any) => {
                                  return (
                                    <li className={`cursor-pointer ${item.id === parseInt(query.id) ? " active" : ''}`} key={index} onClick={() => {
                                      this.toggle(
                                        item, index, videoData.data.id
                                      );
                                    }}>


                                      {item.thumbnailUrl ? (
                                        <img
                                          src={`${FrontendUrl}${item.thumbnailUrl}`}
                                          alt=""
                                          max-width="100%"
                                          className="video-main"
                                          width="180"
                                          height="140px"
                                        />
                                      ) : (
                                          <img src={noImage} alt=""
                                            className="video-main"
                                            width="180"
                                            max-width='100%'
                                            height="140px" />
                                        )}


                                      <span className="mob-sub-title">{item && item.title && item.title.length < 30 ? item.title : item.title.substr(0, 50) + "..."}</span>
                                    </li>
                                  );
                                }) : null}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div >
                  </section >
                </div>
              </div>
            </>)
        }
      </>
    );
  }
}

const mapStateToProps: any = (state: IRootState) => ({
  videoDetailReducer: state.videoDetailReducer,
  SelectedVideoReducer: state.SelectedVideoReducer,
  PausedVideoReducer: state.PausedVideoReducer,
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    getVideoInfo: () => {
      dispatch(videoDetailRequest());
    },
    getSelectedVideo: (data: any) => {
      dispatch(getSelectedVideoRequest(data));
    },
    pausedTimeData: (data: any) => {
      dispatch(pausedTimeRequest(data));
    },
    submitRatingData: (data: any) => {
      dispatch(submitRatingRequest(data));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(view_Video);

